import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Checkbox } from "../ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { api, formatApiError } from "../../lib/api";
import { VERIFY_CHECKS } from "../../lib/platform";
import { FieldError } from "../common/States";

export default function VerifyDialog({ company, onClose, onDone }) {
  const [checks, setChecks] = useState(company.verification?.checks || []);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const toggle = (k, v) => setChecks(v ? [...checks, k] : checks.filter((c) => c !== k));
  const submit = async (result) => {
    if (note.trim().length < 5) { setError("Note de vérification requise (5 caractères min.)"); return; }
    setBusy(true);
    try { await api.post(`/admin/companies/${company.id}/verify`, { result, checks, note: note.trim() }); toast.success("Vérification enregistrée"); onDone(); }
    catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => { if (!o) { onClose(); } }}>
      <DialogContent data-testid="admin-verify-dialog">
        <DialogHeader><DialogTitle>Vérifier — {company.name}</DialogTitle></DialogHeader>
        <div className="space-y-2">
          {Object.entries(VERIFY_CHECKS).map(([k, l]) => (
            <label key={k} className="flex items-center gap-2 text-sm"><Checkbox checked={checks.includes(k)} onCheckedChange={(v) => toggle(k, !!v)} data-testid={`admin-verify-check-${k}`} />{l}</label>
          ))}
        </div>
        <Textarea rows={3} maxLength={500} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Constats et pièces vérifiées (tracé dans l'historique)" data-testid="admin-verify-note-input" />
        <FieldError>{error}</FieldError>
        <DialogFooter>
          <Button variant="outline" disabled={busy} onClick={() => submit("needs_info")} data-testid="admin-verify-needs-info">Informations manquantes</Button>
          <Button disabled={busy} onClick={() => submit("verified")} data-testid="admin-verify-confirm">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Marquer vérifiée</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
